<template>
  <el-dialog
    title="设置代理"
    :visible.sync="dialogVisible"
    customClass="customWidth"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="mini"
    >
      <el-form-item
        prop="legal"
        label="微信呢称"
      >
        {{userName}}
      </el-form-item>
      <el-form-item
              prop="legal"
              label="姓名"
      >
        {{legal}}
      </el-form-item>
      <el-form-item
        prop="userName"
        label="代理级别"
      >
          <div v-if="shop_agentid=='708000109105169'">
          <div v-if="dl_type=='0'">
            消费者
          </div>
          <div v-else-if="dl_type=='1'">
            消费商
          </div>
          <div v-else-if="dl_type=='2'">
            运营商
          </div>
          <div v-else-if="dl_type=='3'">
            运营中心
          </div>
          <div v-else-if="dl_type=='4'">
            分公司
          </div>
          </div>
          <div  v-else-if="shop_agentid=='708000109106094'">
              <div v-if="dl_type=='-1'">
                  普通用户
              </div>
              <div v-else-if="dl_type=='0'">
                  商局会员
              </div>
              <div v-else-if="dl_type=='1'">
                  商局主任
              </div>
              <div v-else-if="dl_type=='2'">
                  商局局长
              </div>
              <div v-else-if="dl_type=='3'">
                  商局合伙人
              </div>
          </div>
          <div  v-else-if="shop_agentid=='708000109113477' ||shop_agentid=='708000109118582'　||shop_agentid=='708000109107183'">
              <div v-if="dl_type=='-1'">
                  普通用户
              </div>
              <div v-else-if="dl_type=='1'">
                  经销商
              </div>
              <div v-else-if="dl_type=='2'">
                  渠道商
              </div>
              <div v-else-if="dl_type=='3'">
                  合伙人
              </div>
          </div>

      </el-form-item>
        <div v-if="shop_agentid=='708000109105169'">
      <el-form-item
        prop="prov_cd"
        label="升级为"
        :rules="[{ required: true, message: '不能为空'}]"
      >

        <el-select
                class="filter-item"
                v-model="form.prov_cd"
                placeholder="请选择"

        >
          <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
        </div>
        <div  v-else-if="shop_agentid=='708000109106094'">
            <el-form-item
                    prop="prov_cd"
                    label="升级为"
                    :rules="[{ required: true, message: '不能为空'}]"
            >

                <el-select
                        class="filter-item"
                        v-model="form.prov_cd"
                        placeholder="请选择"

                >
                    <el-option
                            v-for="item in typeOptions2"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
        </div>

        <div  v-else-if="shop_agentid=='708000109113477' ||shop_agentid=='708000109118582' ||shop_agentid=='708000109107183'">
            <el-form-item
                    prop="prov_cd"
                    label="升级为"
                    :rules="[{ required: true, message: '不能为空'}]"
            >

                <el-select
                        class="filter-item"
                        v-model="form.prov_cd"
                        placeholder="请选择"

                >
                    <el-option
                            v-for="item in typeOptions3"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
        </div>


    <el-form-item>
      <el-button
              type="primary"
              :loading="loading"
              @click="saveUser"
      >保存</el-button>
      <el-button @click="close">取消</el-button>
    </el-form-item>
    </el-form>
  </el-dialog>

</template>
<style>
  .customWidth{
    width:80%;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js';
export default {
  name: "twoagentyEditForm",
  props: {
      oneagent: Object,
    value: Boolean
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
        userName:"",
      legal:"",
      agenttype:"",
      dl_type:"",
        shop_agentid:"",
      form: {
          prov_cd:""
      },
        typeOptions: [   {
            value: "0",
            label: "消费者"
        },{
          value: "1",
          label: "消费商"
        },{
          value: "2",
          label: "运营商"
        },{
          value: "3",
          label: "运营中心"
        },{
          value: "4",
          label: "分公司"
        }],
        typeOptions2: [   {
            value: "-1",
            label: "普通用户"
        },{
            value: "0",
            label: "商局会员"
        },{
            value: "1",
            label: "商局主任"
        },{
            value: "2",
            label: "商局局长"
        },{
            value: "3",
            label: "商局合伙人"
        }],
        typeOptions3: [   {
            value: "-1",
            label: "普通用户"
        },{
            value: "1",
            label: "经销商"
        },{
            value: "2",
            label: "渠道商"
        },{
            value: "3",
            label: "合伙人"
        }]
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
    dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {

    dialogOpen() {
      this.$refs.form.resetFields();
      if (this.oneagent.userId) {

          this.userName = this.oneagent.userName;
        this.legal = this.oneagent.legal;
        this.agenttype= this.oneagent.agenttype;
        this.dl_type=this.oneagent.dl_type;
          this.shop_agentid=this.oneagent.shop_agentid;
      } else {
        this.form = {};
      }

    },
      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                  if (this.oneagent.userId) {
                      this.loading = true;
                      agentService.saveShDltype({ ...this.form,agentid:this.oneagent.agentid,dl_gl:this.oneagent.dl_type,kkk:1,shop_id:util.cookies.get('agentid')})
                          .then(data => {
                              this.loading = false;
                              this.dialogVisible = false;
                              this.$emit("submit");
                          });
                  }
              } else {
                  return false;
              }
          });
      },
    close() {
      this.$refs["form"].resetFields();
      this.dialogVisible = false;
    }
  }
};
</script>

